import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shareFetchError: {
    id: 'SHARE_FETCH_ERROR',
    defaultMessage: 'Das hat leider nicht geklappt.',
  },
  shareFetchErrorRetry: {
    id: 'SHARE_FETCH_ERROR_RETRY',
    defaultMessage: 'Erneut versuchen.',
  },
  shareExternalLinkError: {
    id: 'SOCIAL_SHARE_EXTERNAL_LINK_ERROR',
    defaultMessage: 'Das Teilen dieser URL wird leider nicht unterstützt.',
  },
});
